import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data
  })
}
// 获取用户信息
export function getInfo(data) {
  return request({
    url: '/sys/user/info',
    method: 'get',
    data
  })
}
// 退出登录
export function logout() {
  return request({
    url: '/sys/logout',
    method: 'post'
  })
}
// 获取动态路由
export function getRouteList(params) {
  return request({
    url: '/sys/menu/nav',
    method: 'get',
    params
  })
}
// 修改密码
export function userPassword(data) {
  return request({
    url: '/sys/user/password',
    method: 'post',
    data
  })
}
